import { TableParams } from '../types';

export const reportTypes = {
  GET_REPORTS: 'GET_REPORTS',
  GET_USER_HEALTH_REPORT_BY_ID: 'GET_USER_HEALTH_REPORT_BY_ID',
  GET_USER_LOCATION_REPORT_BY_ID: 'GET_USER_LOCATION_REPORT_BY_ID',
  GET_USER_CONTACT_REPORT_BY_ID: 'GET_USER_CONTACT_REPORT_BY_ID',
};

export type IReportState = Readonly<{
  reports: Array<any>;
}>;


export type GetReportDetailParam = { id: string };

export type GetReportsParams = TableParams & { [key: string]: string };
